export const REQUEST_ERROR_MESSAGE = 'Ошибка сервера';

export const FORM_NAME = 'product-invoice';

export const REQUIRED_FIELDS = ['product_invoice'];
